import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsNewsFeedEnabled() {
  return useCbhFlag(CbhFeatureFlag.NEWS_FEED_ENABLED, {
    defaultValue: false,
  });
}
